<template>
  <div>
    <div @click="reset" class="-reset -reset-filter">Reset</div>
    <div>
      <div v-for="(o, i) in options" :key="i" :class="{ selected: o.selected }">
        <wt-check-box
          @changed="changed($event, o)"
          :checked="o.selected"
          :label-right="o.label"
        ></wt-check-box>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  computed: Object.assign(
    {
      contextFilter() {
        return this.contextFilters[this.filterKey];
      },
      options() {
        return this.contextFilter.options;
      },
    },
    app.Vuex.mapGetters(['contextFilters'])
  ),

  props: {
    filterKey: {
      type: String,
      required: true,
    },
  },

  methods: Object.assign({
    reset() {},
    changed(value, option) {
      option.selected = value;
      this.$emit('search');
    },
  }),
};
</script>
